import UniMenu from "../UniMenu/UniMenu";

const WrapperPage = (props: any) => (
    <>
        <UniMenu activeRoute={props.activeRoute} activeSubRoute={props.activeSubRoute} />
        {props.children}
    </>
)

export default WrapperPage;